// extracted by mini-css-extract-plugin
module.exports = {"activatePlan":"ActivatePlan_activatePlan__Ek0KB"};